import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectQuotView } from '../../Selectors/Master/ItemSelectors';
import { fetchQuotViewlist } from '../../../Store/PHPSlice/Sale/Quotation';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';

const QuotPrint = () => {
    const [formData, setFormData] = useState({
        dt: '',
        quotNo: '',
        itemNm: '',
        firmNm: '',
        priceNm: '',
        partyNm: '',
        schlNm: '',
        jobrate: '',
        outSrc: '',
        extra: '',
        mcloth: '',
        mrate: '',
        mpanna: '',
        m1cloth: '',
        m1rate: '',
        m1panna: '',
        m2cloth: '',
        m2rate: '',
        m2panna: '',
        m3cloth: '',
        m3rate: '',
        m3panna: '',
        firmId: ''
    });

    const { Id } = useParams();
    const dispatch = useDispatch();
    const viewlist = useSelector(selectQuotView);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed

    useEffect(() => {
        dispatch(fetchQuotViewlist(Id))
    }, [Id, dispatch]);

    useEffect(() => {
        if (viewlist.data && viewlist.data.length > 0) {
            const item = viewlist.data[0];
            // console.log(item);
            setFormData(prev => ({
                ...prev,
                dt: item.dt || '',
                quotNo: item.quotNo || '',
                itemNm: item.itemNm || '',
                firmNm: item.firmNm || '',
                priceNm: item.grpNm || '',
                partyNm: item.partyNm || '',
                schlNm: item.schoolNm || '',
                jobrate: item.jobrate || '',
                outSrc: item.outSrc || '',
                extra: item.extra || '',
                mcloth: item.clothNm || '',
                mrate: item.rate || '',
                mpanna: item.panna || '',
                m1cloth: item.m1cloth || '',
                m1rate: item.m1rate || '',
                m1panna: item.m1panna || '',
                m2cloth: item.m2cloth || '',
                m2rate: item.m2rate || '',
                m2panna: item.m2panna || '',
                m3cloth: item.m3cloth || '',
                m3rate: item.m3rate || '',
                m3panna: item.m3panna || '',
                firmId: item.firmId || ''
            }));
        }
    }, [viewlist]);

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    var itemData = viewlist.avgs.length > 0 ? {
        size: viewlist.avgs.map(val => val.size),
        rate: viewlist.avgs.map(val => parseFloat(val.rate))
    } : [];
    
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                        <h3 className='centered-heading'>Quotation</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>

                                <tr>
                                    <td style={{ width: '200px' }}>Quot No.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.quotNo}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>
                                    <td>:</td>
                                    <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Party</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.partyNm}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>School</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.schlNm}</td>

                                </tr>
                            </tbody>

                        </table>

                        <h3 className='centered-heading'>Price List</h3>

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        {itemData.size ? itemData.size.map((item, index) => (
                                            <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item}</TableCell>
                                        )) : ''}


                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{formData.itemNm} {formData.mcloth} {formData.m1cloth !== '0' && formData.m1cloth} {formData.m2cloth !== '0' && formData.m2cloth}
                                            {formData.m3cloth !== '0' && formData.m3cloth}</TableCell>
                                        {itemData.rate ? itemData.rate.map((item, index) => (
                                            <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item}</TableCell>
                                        )) : ''}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                            <div style={{ marginTop: '3%', marginLeft: '5%' }}>
        <h4 style={{ marginBottom: '8px', textDecoration: 'underline' }}>Terms & Conditions</h4>
        <ol style={{ fontSize: '15px', lineHeight: '1.6' }}>
            <li>50% adv on order and remaining at the time of delivery.</li>
            <li>Fancy Shirting & Suiting order as per lump.</li>
            <li>GST will be charged extra.</li>
            <li>Above Rates are applicable only for Basic Pattern , any additional job will be charged extra as below.</li>
            <li>Logo , Embordery or printing will be charge extra.</li>
            <li>Special order will be supplied after 40 to 60 days of final order.</li>
            <li>Price list may be changed without any previous notice.</li>
        </ol>
    </div>
     <div style={{ float: 'right', marginRight: '10%', textAlign: 'center' }}>
                            <h4 style={{ marginBottom: '3rem' }}>Authorized By</h4>
                            <h6>{formData?.firmNm}</h6>
                        </div>
                    </div>
                    <div style={{ margin: '2% 5%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default QuotPrint;
